import { Component, OnChanges, input, signal } from '@angular/core';
import { MatDialog } from '@angular/material/dialog'
import { Title } from '@angular/platform-browser';
import { faEdit, faTrash, faCommentSlash, faMessage, faFileArrowDown, faFilePen, faCheck } from '@fortawesome/free-solid-svg-icons';
import { ReportService } from 'src/app/services/report.service';
import { AccomplishmentService } from 'src/app/services/accomplishment.service';
import { UserService } from 'src/app/services/user.service';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { DialogService } from 'src/app/services/dialog.service';
import { ViewportScroller } from '@angular/common';
import { PrintReportAccomplishmentComponent } from '../print-report-accomplishment/print-report-accomplishment.component';
import { ReportForest } from 'src/app/models/reportForest.model';

@Component({
  selector: 'view-report-accomplishment',
  templateUrl: './view-report-accomplishment.component.html',
  styleUrls: ['./view-report-accomplishment.component.scss'],
  standalone: false
})


export class ViewReportAccomplishmentComponent implements OnChanges {
  //icons
  faEdit = faEdit;
  faTrash = faTrash;
  faCommentSlash = faCommentSlash;
  faFileArrowDown = faFileArrowDown;
  faMessage = faMessage;
  faFile = faFilePen;
  faCheck = faCheck;

  accomplishment_id = input.required<number>();
  report_page_input = input<string>();
  report_page: number = 0;

  report: any;
  reportList: any;
  report_status: any;
  complete: boolean = false;
  nav = signal<string>('');
  current_status: number | undefined = undefined;
  reportSections: any;

  currentUser: any;
  is_co: boolean = false;
  scroll_id: number = -1;

  pageNames = [
    "Fire Report Details",
    "Authorized & Completed Treatments",
    "Additional Information"
  ]

  treatmentTypes: any[] = [];

  maxPage = 3

  constructor(
    public dialog: MatDialog,
    private readonly titleService: Title,
    private readonly reportService: ReportService,
    private readonly accomplishmentService: AccomplishmentService,
    private readonly userService: UserService,
    private readonly toast: ConfirmationToastComponent,
    private readonly dialogService: DialogService,
    private readonly viewportScroller: ViewportScroller,
  ) {
    this.titleService.setTitle("BAER - View Accomplishment Report");
    this.reportSections = this.reportService.getReportPageList();
  }

  ngOnChanges(): void {
    if (this.scroll_id == -1) this.viewportScroller.scrollToPosition([0, 0]);
    this.dialogService.openSpinner();
    let relations: string;
    let page = (parseInt(this.report_page_input() ?? ""))
    page ??= 1
    let pageName = this.pageNames[page - 1]
    if (page >= this.pageNames.length) pageName = "End";
    relations = '&relations=accomplishment_treatments.forest_treatment,additional_reports';
    this.accomplishmentService.getAccomplishment(this.accomplishment_id(), relations).subscribe((report: any) => {
      this.report = report.accomplishments[0];
      this.setReportStatus();
      this.setPage();
      this.nav.set('');
      const reportRelations = '&relations=assessment,forests.treatments.treatment_specifications,forests.treatments.treatment_option,forests.treatments.treatment_type';
      this.reportService.getReportList(this.report.assessment_id, reportRelations).subscribe((reports: any) => {
        let reportList = reports.reports.filter((report: any) => (report.authorization_status_id == 4 || report.authorization_status_id == 6)); //ignore pre-assessment and not funding auth
        reportList = reportList.sort((reportA: any, reportB: any) => reportB.report_id - reportA.report_id);
        this.reportList = reportList;
        this.getTypeList();
        if (!this.report.report_name) this.setReportName(reportList[0].submission_date)
      })
    })
    this.userService.getUserProfile().then((user) => {
      this.currentUser = user;
    })
  }

  getTypeList() {
    this.reportList.forEach((report: any) => {
      report.forests.forEach((forest: ReportForest) => {
        this.forestTotal(forest.treatments);
      });
    })

    this.treatmentTypes = this.treatmentTypes.reduce((acc, curr) => {
      if (!(acc.find((item: any) => item.treatment_type_id === curr.treatment_type_id)))
        acc.push(curr);
      return acc;
    }, <any>[]);
  }

  forestTotal(treatments: any[] | undefined) {
    if (treatments == null) return;
    for (let item of treatments) {
      this.treatmentTypes.push(item.treatment_type)
    }
  }

  setReportName(submission_date: any) {
    if (submission_date) {
      let today = new Date();
      const submission_date_as_date = new Date(submission_date)
      const utc1 = Date.UTC(submission_date_as_date.getFullYear(), submission_date_as_date.getMonth(), submission_date_as_date.getDate());
      const utc2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      // Calculate difference in days
      const msPerDay = 1000 * 60 * 60 * 24;
      const days = Math.floor((utc2 - utc1) / msPerDay);
      switch (true) {
        case days >= 547:
          this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (18 months)'
          break
        case days >= 365:
          this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (1 year)'
          break
        case days >= 182:
          this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (6 months)'
          break
        case days >= 90:
          this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (90 days)'
          break
        case days >= 60:
          this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (60 days)'
          break
        default:
          this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (30 days)'
      }
    } else this.report.report_name = this.reportList[0].assessment.baer_name + ' Accomplishments (30 days)'
  }

  subLoaded() {
    this.dialogService.closeSpinner();
    let element = document.getElementById(this.scroll_id.toString());
    let y = element?.getBoundingClientRect().y;
    if (!y) y = 0;
    y = y + window.scrollY - 120;//adjust for header and existing scroll location
    setTimeout(() => { //even after afterviewinit, still needs to wait for sub to load
      window.scrollTo({ behavior: "smooth", top: y });
    }, 100);
  }

  save_close() {
    this.nav.set('close');
  }

  forward() {
    this.nav.set('forward');
  }

  back() {
    this.nav.set('back');
  }

  goToPage(page: number, scroll_id?: number) {
    this.scroll_id = scroll_id ?? -1;
    if (this.report_page == page) {
      this.subLoaded();
      return // don't navigate to current page
    }
    this.nav.set(page.toString());
  }

  statusChange(status: any) {
    this.current_status = status;
    this.setReportStatus();
    const filtered_status = this.report_status.filter((status: any) => status.status < 2)
    if (filtered_status.length >= 1) {
      this.complete = false;
    } else this.complete = true;
  }

  setReportStatus() {
    let status_3 = this.report.page_3_status_id;
    if (this.report_page == 3) status_3 = this.current_status ?? this.report.page_3_status_id;
    this.report_status = [
      { report_page: 1, status: this.report.page_1_status_id },
      { report_page: 2, status: this.report.page_2_status_id },
      { report_page: 3, status: status_3 }
    ]
  }

  setPage() {
    //if no page passed in, set page to latest page not finished
    if (!this.report_page_input()) {
      const filtered_status = this.report_status.filter((status: any) => status.status < 2)
      if (filtered_status.length >= 1) {
        // issue with dynamic page load. report must load first to get status but then report details is dynamic after page select so there is circular logic. defaulting to page 1 for now
        this.report_page = 1;
        this.complete = false;
      } else {
        this.report_page = 1;
        this.complete = true;
      }
    }
    else {
      this.report_page = (parseInt(this.report_page_input() ?? '') ?? 0);
    }
  }

  findPage(pageNum: any) {
    return this.reportSections.find((x: any) => x.pageNum == pageNum).pageName;
  }

  download() {
    this.dialog.open(PrintReportAccomplishmentComponent, {
      width: "1700px",
      height: "0px",
      data: {
        accomplishment_id: this.accomplishment_id()
      }
    });
  }
}
